import NetworkCard from './NetworkCard';

export default NetworkCard;
